module.exports = __webpack_public_path__ + "img/banana.528801b2.jpeg";